import React from 'react';
import { Chip } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { StatusEnums } from '../../../utils/settings';

const StatusChip = ({
  status = 'default',
  label,
  type = 'outlined', // 'outlined' | 'filled'
  sx = {},
  ...rest
}) => {
  const theme = useTheme();

  const statusStyles = {
    [StatusEnums.Pending]: {
      color: theme.palette.text.primary,
      borderColor: theme.palette.warning.main,
      backgroundColor: alpha(theme.palette.warning.main, 0.1),
    },
    [StatusEnums.NotVerified]: {
      color: theme.palette.text.primary,
      backgroundColor: alpha(theme.palette.error.main, 0.1),
      borderColor: theme.palette.error.main
    },
    [StatusEnums.Verified]: {
      color: theme.palette.text.primary,
      backgroundColor: alpha(theme.palette.success.main, 0.1),
      borderColor: theme.palette.success.main
    },
    [StatusEnums.Approved]: {
      color: theme.palette.text.primary,
      backgroundColor: alpha(theme.palette.success.main, 0.1),
      borderColor: theme.palette.success.main
    },
    [StatusEnums.PartiallyCompleted]: {
      color: theme.palette.text.primary,
      backgroundColor: alpha(theme.palette.info.main, 0.1),
      borderColor: theme.palette.info.main
    },
    [StatusEnums.Completed]: {
      color: theme.palette.text.primary,
      backgroundColor: alpha(theme.palette.success.main, 0.1),
      borderColor: theme.palette.success.main
    },
    [StatusEnums.Success]: {
      color: theme.palette.text.primary,
      backgroundColor: alpha(theme.palette.success.main, 0.1),
      borderColor: theme.palette.success.main
    },
    [StatusEnums.Cancelled]: {
      color: theme.palette.text.primary,
      backgroundColor: alpha(theme.palette.error.main, 0.1),
      borderColor: theme.palette.error.main
    },
    default: {
      color: theme.palette.text.secondary,
      backgroundColor: alpha(theme.palette.grey[300], 0.1),
      borderColor: theme.palette.grey[300]
    }
  };

  const style = statusStyles[status] || statusStyles.default;
  const isFilled = type === 'filled';
  const isText = type === 'text';

  return (
    <Chip
      label={label}
      variant="outlined"
      sx={{
        fontWeight: 500,
        fontSize: { xs:'11px', sm:'13px' },
        // height: {xs: 25, sm: 32},
        lineHeight: '24px',
        px: { xs: 1, sm: 1 },
        borderRadius: '16px',
        color: isFilled
        ? theme.palette.common.white
        : isText
        ? style.color
        : style.color,
      backgroundColor: isText ? 'transparent' : isFilled ? style.borderColor : style.backgroundColor,
      border: isText ? 'none' : isFilled ? 'none' : `1px solid ${style.borderColor}`,
      ...sx,
      }}
      {...rest}
    />
  );
};

export default StatusChip;
